export default __webpack_public_path__ + "8215a0c61f4e48610618bf1def12f94c.svg";